<template>
  <v-container fluid class="pa-7">
    <header-component :title="$vuetify.lang.t('$vuetify.navigation.packages')"> </header-component>

    <div class="d-sm-flex gap-4">
      <div class="flex-grow-1">
        <Transition class="flex-grow-1">
          <v-alert
            v-if="
              alertActivated &&
              ((order.state.id !== ORDER_STATE.PACKING && order.state.id !== ORDER_STATE.CHECKING) ||
                form.order_id === order.id)
            "
            border="left"
            color="green"
            dark
          >
            {{ $vuetify.lang.t(`$vuetify.packages.success1`) }} <strong>{{ form.order_id }}</strong>
            {{ $vuetify.lang.t(`$vuetify.packages.success2`) }}
          </v-alert>
          <v-alert
            v-else-if="
              alertActivated &&
              order &&
              (order.state.id === ORDER_STATE.PACKING || order.state.id === ORDER_STATE.CHECKING)
            "
            border="left"
            color="green"
            dark
          >
            {{ $vuetify.lang.t(`$vuetify.packages.success1`) }} <strong>{{ form.order_id }}</strong>
            {{ $vuetify.lang.t(`$vuetify.packages.success3`) }}
          </v-alert>
        </Transition>
      </div>

      <div v-if="pdfUrl && pdfUrlType === 'packeta'">
        <v-btn class="white--text" color="#ba1b02" @click="pdfDialog = true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 1280" height="36">
            <path
              d="m655 576.8-15 7.2-15-7.2-208.9-103.2 99.1-37.8 214.3 104zm209.2-103.2-74.8 36.3-216.8-96.4 67.5-26z"
              fill="#fff"
            />
            <path
              d="m648.1 320.8 274.2 105.9-38.5 30.9L640 363.2l-243.8 94.4-38.5-30.9 274.5-105.9zm242 145.9 45.4-17.4-34.1 281.1-6.9 12.5-240.6 216.3-7.8-49.8 214.3-192.5zM385.4 742.8l-6.8-12.5-34.1-281 45.4 17.4 29.9 250.4 214.1 192.5-7.6 49.6z"
              fill="#fff"
            />
            <path
              d="m795.2 518.7 69.2-42.2-27.2 226.4L641.5 879l10.8-272.7 85.8-52.8-5.7 133.7 53.5-37.5z"
              fill="#b4b4b4"
            />
            <path d="m627.7 606.3 10.8 272.5-195.4-175.9-27.5-226.4z" fill="#dedede" />
          </svg>
          Poslední štítek zásilkovny
        </v-btn>
      </div>

      <div v-if="pdfUrl && pdfUrlType === 'cp'">
        <v-btn class="white--text" color="#1d3778" @click="pdfDialog = true">
          <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 100 45.18">
            <g>
              <path
                fill="#f9cf47"
                d="m1.53,0C.69,0,0,.68,0,1.52c.77,21.88,18.1,39.57,39.89,41.01.95.06,1.92.02,2.88.02,3.1,0,6.32-.54,9.23-1.18,9.41-2.06,16.39-10.38,16.39-20.44,0-.69-.04-1.38-.1-2.05-.12-1.25-.36-2.48-.69-3.66C65.1,6.44,56.99,0,47.37,0s-17.74,6.44-20.23,15.23c1.72,6.06,6.12,11,11.84,13.49-1.91-2.04-3.08-4.78-3.08-7.78,0-6.31,5.13-11.42,11.47-11.42s11.47,5.11,11.47,11.42c0,3.01-1.17,5.74-3.08,7.78-2.09,2.23-5.08,3.64-8.39,3.64-9.31,0-17.33-5.53-20.92-13.47-.53-1.17-.96-2.39-1.29-3.66-.47-1.82-.72-3.74-.72-5.71,0-2.74.49-5.38,1.38-7.81.04-.11.08-.22.13-.33.02-.08.02-.15.02-.23,0-.63-.51-1.14-1.15-1.14H1.54"
              />
              <path
                fill="#f9cf47"
                d="m78.76,1.15c.72,2.67,1.1,5.47,1.1,8.36,0,9.78-4.36,18.55-11.25,24.49-1.72,1.3-3.19,2.59-6.07,4.11,5.21-4.9,7.77-10.65,7.77-17.17,0-1.97-.25-3.89-.72-5.71.47-1.82.72-3.74.72-5.71,0-2.81-.51-5.51-1.44-8-.04-.12-.06-.25-.06-.38,0-.63.51-1.14,1.15-1.14h7.34c.7,0,1.3.51,1.48,1.15"
              />
            </g>
          </svg>
          Poslední štítek ČP
        </v-btn>
      </div>
    </div>

    <v-row>
      <v-col cols="lg-4" offset-lg="4">
        <h4 class="text-uppercase mt-6 mb-3">
          {{ $vuetify.lang.t(`$vuetify.packages.todayPackaged`) }}
        </h4>
        <v-row class="mb-6">
          <v-col cols="6">
            <v-card
              elevation="2"
              class="text-center"
              :class="remaining && remaining.user.today_orders > 0 ? 'today-searched--green' : 'today-searched--orange'"
            >
              <div class="text-overline px-4 pt-2">
                {{ $vuetify.lang.t(`$vuetify.searching.orders`) }}
              </div>
              <v-card-title v-if="remaining && !remainingLoading" class="pt-0 justify-center">
                {{ remaining.user.today_orders }}
              </v-card-title>
              <v-progress-circular v-else indeterminate color="primary" :size="32" class="mb-4" />
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card
              elevation="2"
              class="text-center"
              :class="remaining && remaining.user.today_items > 0 ? 'today-searched--green' : 'today-searched--orange'"
            >
              <div class="text-overline px-4 pt-2">
                {{ $vuetify.lang.t(`$vuetify.searching.pieces`) }}
              </div>
              <v-card-title v-if="remaining && !remainingLoading" class="pt-0 justify-center">
                {{ remaining.user.today_items }}
              </v-card-title>
              <v-progress-circular v-else indeterminate color="primary" :size="32" class="mb-4" />
            </v-card>
          </v-col>
        </v-row>

        <h4 class="text-uppercase mt-6 mb-3">
          {{ $vuetify.lang.t(`$vuetify.packages.remains`) }}
        </h4>
        <v-row class="mb-6">
          <v-col cols="6">
            <v-card elevation="2" class="text-center">
              <div class="text-overline px-4 pt-2">
                {{ $vuetify.lang.t(`$vuetify.searching.orders`) }}
              </div>
              <v-card-title v-if="remaining && !remainingLoading" class="pt-0 justify-center">
                {{ remaining.remaining_orders }}
              </v-card-title>
              <v-progress-circular v-else indeterminate color="primary" :size="32" class="mb-4" />
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card elevation="2" class="text-center">
              <div class="text-overline px-4 pt-2">
                {{ $vuetify.lang.t(`$vuetify.searching.pieces`) }}
              </div>
              <v-card-title v-if="remaining && !remainingLoading" class="pt-0 justify-center">
                {{ remaining.remaining_items }}
              </v-card-title>
              <v-progress-circular v-else indeterminate color="primary" :size="32" class="mb-4" />
            </v-card>
          </v-col>
        </v-row>

        <v-progress-circular v-if="searchPending && !REQUEST_STATUS.FAIL" indeterminate color="primary" class="my-4" />
        <section v-if="order && !searchPending && form.order_id !== order.id">
          <div class="d-flex align-center gap-4 pb-4">
            <h2 class="header-title w-initial">
              {{ order.id }}
            </h2>

            <v-chip v-if="isFirstTimeCustomer" class="font-weight-bold" color="success" size="large" label>
              {{ $vuetify.lang.t('$vuetify.labels.newCustomer').toUpperCase() }}
            </v-chip>
          </div>

          <div v-if="order.state.id === ORDER_STATE.PACKING || order.state.id === ORDER_STATE.CHECKING">
            <div v-if="order.payment.payment_method_id === 4" class="d-flex align-start gap-4 mb-4">
              <v-icon color="orange" class="flex-8"> $vuetify.icons.triangleExclamation </v-icon>
              <p class="ma-0">
                <strong>{{ order.payment.name.ces }}</strong>
              </p>
            </div>

            <div class="d-flex align-start gap-4 mb-4">
              <v-icon color="primary" class="flex-8"> $vuetify.icons.puzzle </v-icon>
              <p class="ma-0" v-if="order.items">
                {{ totalItemsAmount }} {{ $vuetify.lang.t(`$vuetify.packages.pieces`) }}
              </p>
              <v-progress-circular v-else indeterminate color="primary" :size="24" />
            </div>

            <div class="d-flex align-start gap-4 mb-4">
              <v-icon color="primary" class="flex-8"> $vuetify.icons.truck </v-icon>
              <p class="ma-0">{{ order.shipping.name.ces }}</p>
            </div>

            <div class="d-flex align-start gap-4 mb-4">
              <v-icon color="primary" class="flex-8"> $vuetify.icons.user </v-icon>
              <div>
                <p class="ma-0">
                  <strong>{{ order.customerName }}</strong>
                  <template v-if="isFirstTimeCustomer">
                    | {{ $vuetify.lang.t('$vuetify.labels.newCustomer').toUpperCase() }}
                  </template>
                </p>
                <p class="ma-0">{{ order.email }}</p>
                <p class="ma-0">{{ phoneNumber }}</p>
              </div>
            </div>
            <div class="d-flex justify-center">
              <v-btn color="grey" class="text-normal mb-4" :disabled="!countDown" @click="exitPackaging"
                >{{ $vuetify.lang.t(`$vuetify.packages.error`) }} ({{ countDown }} s)</v-btn
              >
              <v-dialog persistent v-model="dialog" max-width="290">
                <v-card>
                  <v-card-title class="text-h5">
                    {{ $vuetify.lang.t(`$vuetify.packages.popup.error`) }}
                  </v-card-title>

                  <v-card-text>
                    {{ $vuetify.lang.t(`$vuetify.packages.popup.info1`) }}
                    {{ order.id }}
                    {{ $vuetify.lang.t(`$vuetify.packages.popup.info2`) }}
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="green darken-1" text @click="closePackaging">
                      {{ $vuetify.lang.t(`$vuetify.packages.popup.ok`) }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <p class="text-center">{{ $vuetify.lang.t(`$vuetify.packages.continue`) }}</p>
          </div>
          <div v-else class="mb-4 color-red">{{ $vuetify.lang.t(`$vuetify.packages.message`) }}</div>
        </section>

        <div class="relative d-flex">
          <v-text-field
            :label="$vuetify.lang.t('$vuetify.search.orderById')"
            type="number"
            ref="mainInput"
            outlined
            single-line
            hide-details
            v-model="searchQuery"
            @input="search"
            clearable
            :disabled="searchPending"
          />
          <v-progress-circular v-if="searchPending" indeterminate color="primary" class="input-loading my-3" />
        </div>

        <p v-if="this.status === REQUEST_STATUS.FAIL" class="color-red mt-2">
          {{ $vuetify.lang.t(`$vuetify.packages.badId`) }}
        </p>
        <p
          v-if="this.searchQuery === this.searchedId && this.status === REQUEST_STATUS.SUCCESS && order"
          class="color-red mt-2"
        >
          {{ $vuetify.lang.t(`$vuetify.packages.actualId`) }}
        </p>
        <div class="d-flex mt-4 w-100">
          <QrCodeReaderComponent @decode="decode($event)" :is-order="false" width="100%" height="56" class="w-100" />
        </div>

        <div class="text-center">
          <v-dialog v-model="pdfDialog" persistent width="500px">
            <v-card class="pdf-dialog">
              <v-progress-circular v-if="isLoading" indeterminate color="primary"></v-progress-circular>

              <iframe v-else ref="packetaPdf" :src="pdfUrl" frameborder="0"></iframe>

              <v-card-actions>
                <v-btn color="red" text @click="pdfDialog = false">Zavřít</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="printPdf()">Tisknout</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-if="order" v-model="packetaErrorDialog" persistent width="500px">
            <v-card>
              <v-card-title class="text-h5 amber mb-5 color-white">
                <v-icon color="white" class="mb-1 mr-3"> $vuetify.icons.triangleExclamation </v-icon>
                Neplatná pobočka Zásilkovny
              </v-card-title>

              <v-card-text>
                <strong class="text--black"> Objednávka číslo: {{ order.id }} </strong>
                <br />
                {{ order.shipping.shipping_option_id }} - {{ order.shipping.shipping_option_name }}
              </v-card-text>

              <v-divider />

              <v-card-actions>
                <v-btn color="red" text @click="resetPackaging()"> Zavřít </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="setNewPacketaOption()"> Nastavit novou pobočku zásilkovny </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HeaderComponent from '../../components/layout/HeaderComponent.vue';
import QrCodeReaderComponent from '../../components/global/QrCodeReaderComponent.vue';
import REQUEST_STATUS from '../../common/enums/requestStatus';
import SHIPPING_SERVICE from '../../common/enums/shippingService';
import ORDER_STATE from '../../common/enums/orderState';
import { isFirstTimeCustomer } from '@/common/helpers/customer';
import { firstTimeCustomerMixin } from '@/mixins/firstTimeCustomer';
import { OrdersShippingMethodsApiService } from '@/common/services/orders-shipping-methods.api.service';

export default {
  name: 'SearchPackage',

  mixins: [firstTimeCustomerMixin],

  components: {
    HeaderComponent,
    QrCodeReaderComponent,
  },

  data() {
    return {
      REQUEST_STATUS,
      ORDER_STATE,
      searchQuery: null,
      searchedId: null,
      searchPending: false,
      countDown: 30,
      timeout: 0,
      isCanceled: false,
      dialog: false,
      alertActivated: false,
      form: {},
      remainingLoading: false,
      lastSent: null,
      packetForm: {
        order_id: null,
        format: 'A7 on A7',
        content_type: 'application/pdf',
        offset: 0,
        dpi: 300,
      },
      packetaErrorDialog: false,
      pdfDialog: false,
      pdfUrl: '',
      pdfUrlType: '',
      isLoading: false,
      isSearchLoading: false,
      isFirstTimeCustomer: false,
    };
  },

  watch: {
    countDown() {
      if (this.countDown === 0) {
        this.saveAllItems();
        // reset the first time customer flag when the timeout expires
        this.isFirstTimeCustomer = false;
      }
    },

    user() {
      this.fetchOrdersRemaining({ idData: { user_id: this.user.id } });
    },
  },

  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      status: 'orders/getStatus',
      storesStatus: 'stores/getStatus',
      getOrder: 'orders/getOrder',
      getPacketLabel: 'packetLabel/getItem',
      remaining: 'orders/getRemaining',
    }),

    order() {
      return this.getOrder(Number(this.searchedId));
    },

    phoneNumber() {
      if (this.order.addresses) {
        const billingAddress = this.order.addresses.find(address => address.type === 2);
        return billingAddress.phone;
      }
      return '\u00a0';
    },

    totalItemsAmount() {
      return this.order.items.reduce((acc, item) => acc + item.amount, 0);
    },
  },

  methods: {
    ...mapActions({
      fetchOrder: 'orders/fetchOrder',
      postOrderItems: 'stores/postOrderItems',
      postPacketLabel: 'packetLabel/postPacketLabel',
      fetchOrdersRemaining: 'orders/fetchOrdersPackagingRemaining',
    }),

    printPdf() {
      const pdfFrame = this.$refs.packetaPdf;
      pdfFrame.contentWindow.print();

      this.pdfDialog = false;
    },

    decode(e) {
      setTimeout(() => {
        this.searchQuery = e;
        this.$forceUpdate();
      }, 100);
    },

    countDownTimer() {
      if (this.countDown > 0) {
        this.timeout = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },

    resetPackaging() {
      this.packetaErrorDialog = false;

      clearTimeout(this.timeout);
      this.countDown = null;
      this.isCanceled = true;
      this.searchQuery = null;
    },

    exitPackaging() {
      this.dialog = true;
      clearTimeout(this.timeout);
      this.countDown = null;

      this.isCanceled = true;
    },

    closePackaging() {
      this.dialog = false;

      this.searchQuery = null;
    },

    async search() {
      if ((this.searchQuery.length === 9 && this.searchQuery !== this.searchedId) || this.isCanceled) {
        if (this.order && this.order.id !== this.lastSent) {
          this.saveAllItems();
        }

        this.isCanceled = false;

        clearTimeout(this.timeout);

        this.form = {};
        this.pdfUrl = '';
        this.pdfUrlType = '';

        this.countDown = null;

        this.searchPending = true;

        this.searchedId = this.searchQuery;

        try {
          await this.fetchOrder(Number(this.searchedId));
        } catch (e) {
          this.searchedId = null;
          this.searchPending = false;
        }

        this.isFirstTimeCustomer = await isFirstTimeCustomer(this.order && this.order.customerId);

        if (
          this.order.shipping.shipping_service === SHIPPING_SERVICE.PACKETA_ADDRESS_DELIVERY ||
          this.order.shipping.shipping_service === SHIPPING_SERVICE.PACKETA ||
          this.order.shipping.shipping_service === SHIPPING_SERVICE.CESKA_POSTA_BALIKOVNA ||
          this.order.shipping.shipping_service === SHIPPING_SERVICE.CESKA_POSTA_NAPOSTU ||
          this.order.shipping.shipping_service === SHIPPING_SERVICE.CESKA_POSTA_BALIK_DO_RUKY
        ) {
          this.countDown = 5;
        } else {
          this.countDown = 30;
        }
        this.countDownTimer();

        this.searchPending = false;
        this.searchQuery = null;

        this.$nextTick(() => {
          this.$refs.mainInput.focus();
        });
      }
    },

    async saveAllItems() {
      if (
        (this.order.state.id === ORDER_STATE.PACKING || this.order.state.id === ORDER_STATE.CHECKING) &&
        !this.isCanceled
      ) {
        this.alertActivated = false;
        this.form.order_id = this.order.id;
        this.form.user_id = this.user.id;

        this.postOrderItems({ url: 'orders-packaging/finish', formData: this.form }).then(response => {
          if (this.storesStatus === 'success') {
            this.alertActivated = true;

            this.lastSent = this.form.order_id;

            if (
              this.order.shipping.shipping_service === SHIPPING_SERVICE.PACKETA_ADDRESS_DELIVERY ||
              this.order.shipping.shipping_service === SHIPPING_SERVICE.PACKETA
            ) {
              this.pdfDialog = true;
              this.isLoading = true;

              this.packetForm.order_id = this.order.id;

              const token = localStorage.getItem(process.env.VUE_APP_JWT_BEARER);

              fetch(`${process.env.VUE_APP_API_URL}/api/v0/third-parties/packeta/packetLabel`, {
                method: 'POST',
                headers: {
                  Authorization: token,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  order_id: this.order.id,
                  format: 'A7 on A7',
                  content_type: 'application/pdf',
                  offset: 0,
                  dpi: 300,
                }),
              })
                .then(response => {
                  if (response.status >= 400 && response.status < 600) {
                    throw response;
                  }
                  return response.blob();
                })
                .then(blob => {
                  const pdfBlob = new Blob([blob], { type: 'application/pdf' });
                  this.pdfUrl = window.URL.createObjectURL(pdfBlob);
                  this.pdfUrlType = 'packeta';

                  this.isLoading = false;
                })
                .catch(error => {
                  this.pdfDialog = false;
                  this.isLoading = false;
                  this.$alertError(this.$vuetify.lang.t('$vuetify.messages.qrCodeBlobError'));
                });
            }

            if (
              this.order.shipping.shipping_service === SHIPPING_SERVICE.CESKA_POSTA_BALIKOVNA ||
              this.order.shipping.shipping_service === SHIPPING_SERVICE.CESKA_POSTA_NAPOSTU ||
              this.order.shipping.shipping_service === SHIPPING_SERVICE.CESKA_POSTA_BALIK_DO_RUKY
            ) {
              this.pdfDialog = true;
              this.isLoading = true;

              this.packetForm.order_id = this.order.id;

              const token = localStorage.getItem(process.env.VUE_APP_JWT_BEARER);

              fetch(`${process.env.VUE_APP_API_URL}/api/v0/third-parties/posta-online/parcel-printing`, {
                method: 'POST',
                headers: {
                  Authorization: token,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  order_id: this.order.id,
                  id_form: 101,
                  shift_horizontal: 0,
                  shift_vertical: 0,
                  position: 0,
                }),
              })
                .then(response => {
                  if (response.status >= 400 && response.status < 600) {
                    throw response;
                  }
                  return response.blob();
                })
                .then(blob => {
                  const pdfBlob = new Blob([blob], { type: 'application/pdf' });
                  this.pdfUrl = window.URL.createObjectURL(pdfBlob);
                  this.pdfUrlType = 'cp';

                  this.isLoading = false;
                })
                .catch(error => {
                  this.pdfDialog = false;
                  this.isLoading = false;
                  this.$alertError(this.$vuetify.lang.t('$vuetify.messages.qrCodeBlobError'));
                });
            }
          } else if (response.isStatus(422) && this.order.shipping.shipping_service === SHIPPING_SERVICE.PACKETA) {
            this.packetaErrorDialog = true;
          } else {
            this.$alertError(this.$vuetify.lang.t('$vuetify.messages.error'));
          }

          this.remainingLoading = true;

          this.fetchOrdersRemaining({ idData: { user_id: this.user.id } }).then(() => {
            this.remainingLoading = false;
          });
        });
      }
    },

    setNewPacketaOption() {
      const packetaApiKey = process.env.VUE_APP_PACKETA_API_KEY;

      const packetaOptions = {
        valueFormat: '"Packeta",id,carrierId,carrierPickupPointId,name,city,street',
        centerExternalId: `I_${this.order.shipping.shipping_option_id}`,
      };

      // eslint-disable-next-line no-undef
      Packeta.Widget.pick(packetaApiKey, this.showSelectedPickupPoint, packetaOptions);
    },

    async showSelectedPickupPoint(point) {
      try {
        await OrdersShippingMethodsApiService.patch(this.order.id, this.order.shipping.id, {
          notify_change: true,
          note: 'vytíženost výdejního místa',
          shipping_option_id: point.id,
        });

        this.packetaErrorDialog = false;

        await this.saveAllItems();
      } catch (e) {
        this.$alertError(e.getFirstValidationErrorMessage());
      }
    },
  },

  mounted() {
    this.$refs.mainInput.focus();

    let packetaScript = document.createElement('script');
    packetaScript.setAttribute('src', 'https://widget.packeta.com/v6/www/js/library.js');
    document.head.appendChild(packetaScript);
  },

  beforeDestroy() {
    // reset the background color when navigating away from the page (method from a mixin)
    this.resetBackground();
  },

  created() {
    if (this.user) {
      this.remainingLoading = true;

      this.fetchOrdersRemaining({ idData: { user_id: this.user.id } }).then(() => {
        this.remainingLoading = false;
      });
    }
  },
};
</script>

<style scoped>
.remaining-search--transparent {
  border-bottom: 0.3rem solid transparent;
}

.today-searched--green {
  border-bottom: 0.3rem solid green;
}

.today-searched--orange {
  border-bottom: 0.3rem solid orange;
}

.pdf-dialog {
  width: 31rem;
  height: 31rem;
}

.pdf-dialog iframe {
  width: 100%;
  height: calc(100% - 4rem);
}

.input-loading {
  position: absolute;
  right: 1rem;
}
</style>
